import * as GLOBALS from "../../globals";

export default function InitScrollAnimations(gsap, gsapScrollTrigger) {
	InitHeroParallax(gsap, gsapScrollTrigger);
	InitCardFadeUp(gsap, gsapScrollTrigger);
}

function InitHeroParallax(gsap, gsapScrollTrigger) {
	const heroElement = document.querySelector(".hero");
	if (heroElement === null || window.innerWidth < GLOBALS.BREAKPOINT_LG) return;

	InitParallax(gsap, gsapScrollTrigger, heroElement);
}

function InitParallax(gsap, ScrollTrigger, parent, start = "top top", end = "bottom top") {
	Array.from(parent.querySelectorAll("[data-parallax]")).forEach((layer) => {
		const speed = layer.dataset.parallaxSpeed;

		const anim = gsap.to(
			layer,
			{
				y: -(parent.offsetHeight * speed),
				ease: "none",
			},
			0
		);

		ScrollTrigger.create({
			trigger: parent,
			start: start,
			end: end,
			scrub: true,
			animation: anim,
		});

		window.addEventListener("resize", () => {
			gsap.set(layer, { x: 0 });
		});
	});
}

function InitCardFadeUp(gsap, ScrollTrigger) {
	const fadeUpContainers = document.querySelectorAll(".card-container:not(.no-animation), .clients-grid:not(.no-animation), .collection-cards:not(.no-animation)");

	fadeUpContainers.forEach((parent) => {
		const fadeUpElements = Array.from(parent.querySelectorAll(".card, .client-item"));

		fadeUpElements.forEach((element, i) => {
			const anim = gsap.fromTo(
				element,
				{
					autoAlpha: 0,
					y: 50,
				},
				{
					duration: 1,
					autoAlpha: 1,
					y: 0,
					delay: 0.75 / (fadeUpElements.length - i),
				}
			);

			ScrollTrigger.create({
				trigger: element,
				animation: anim,
				toggleActions: "play none none none",
				once: true,
			});
		});
	});
}
